<template>
	<div class="desktop-vouchers-page" :class="colourMode">
		<SettingsOverlay
			v-if="showSettings"
			:customer="customer"
			:colourMode="colourMode"
			:safeTop="safeTop"
			@close="showSettings = false"
			@update-pref="updatePref"
			@select-colour-mode="selectColourMode"
		/>
		<ShopVouchersPage v-else />
	</div>
</template>

<script>
import ShopVouchersPage from '@/components/ShopVouchersPage.vue';
import SettingsOverlay from '../components/SettingsOverlay.vue';
import Services from '../../mixins/Services';

export default {
	name: "DesktopShopVouchersPage",
	mixins: [Services],
	components: { ShopVouchersPage, SettingsOverlay },
	emits: ['colour-mode-changed'],
	inject: ['registerSidebar'],
	data() {
		return {
			colourMode: 'light',
			userName: 'there',
			showSettings: false
		}
	},
	computed: {
		safeTop() {
			return parseInt(this.$cookies.get('st') ?? 0);
		}
	},
	methods: {
		updatePref(key, value) {
			if (this.customer?.preferences) {
				this.customer.preferences[key] = value;
				this._savePreferences();
			}
		},
		selectColourMode(mode) {
			this.colourMode = mode;
			localStorage.setItem('mg_colour_mode', mode);
			this.$emit('colour-mode-changed', mode);
		}
	},
	mounted() {
		const savedMode = localStorage.getItem('mg_colour_mode');
		if (savedMode) {
			this.colourMode = savedMode;
		} else {
			this.colourMode = 'light';
			localStorage.setItem('mg_colour_mode', 'light');
		}
		this._getCustomer(() => {
			if (this.customer?.person?.firstName) {
				this.userName = this.customer.person.firstName;
			}
		});
		if (this.registerSidebar) {
			this.registerSidebar({
				config: {
					actionButton: null,
					pageItemsTitle: null
				},
				data: this,
				handlers: {
					onActionClick: () => {},
					onPageItemClick: () => {},
					onPageItemDelete: () => {},
					onPageItemRename: () => {},
					onOpenSettings: () => { this.showSettings = true; }
				}
			});
		}
	}
}
</script>

<style scoped>
.desktop-vouchers-page {
	height: 100%;
	overflow-y: auto;
	background: var(--background-color-main);
}
</style>

<style>
/* Hide mobile header on desktop */
.desktop-vouchers-page .headerBlock {
	display: none !important;
}

/* Must be unscoped to reach into child component */
.desktop-vouchers-page .container {
	width: 100% !important;
	max-width: 100% !important;
	margin-left: 0 !important;
	margin-right: 0 !important;
	padding-left: 0 !important;
	padding-right: 0 !important;
}

.desktop-vouchers-page .smoothScrollContainer {
	margin-left: 0 !important;
	margin-right: 0 !important;
	padding-left: 0 !important;
	padding-right: 0 !important;
}

.desktop-vouchers-page .smoothScrollContainerItem {
	width: 100% !important;
	margin-left: 0 !important;
	padding-right: 0 !important;
}

.desktop-vouchers-page .smoothScrollContainerItem:first-child {
	margin-left: 0 !important;
}

.desktop-vouchers-page .cart-basket-section {
	margin-left: 0 !important;
	margin-right: 0 !important;
}

.desktop-vouchers-page .header {
	margin-left: 0 !important;
	margin-right: 0 !important;
}

.desktop-vouchers-page .topMenuRow {
	margin-left: 0 !important;
	margin-right: 0 !important;
}

/* Dark mode styles */
.desktop-vouchers-page.dark {
	background: var(--dark-bg-primary) !important;
}

.desktop-vouchers-page.dark .shop-voucher-page {
	background: var(--dark-bg-primary);
	color: var(--dark-text-primary);
}

.desktop-vouchers-page.dark .topTabButton {
	background-color: var(--dark-bg-secondary) !important;
	color: var(--dark-text-primary) !important;
}

.desktop-vouchers-page.dark .topTabButton.selected {
	background-color: var(--dark-accent) !important;
	color: white !important;
}

.desktop-vouchers-page.dark .search-row .v-field {
	background-color: var(--dark-bg-secondary) !important;
}

.desktop-vouchers-page.dark .search-row .v-field input {
	color: var(--dark-text-primary) !important;
}

.desktop-vouchers-page.dark .sectionHeader h2,
.desktop-vouchers-page.dark h2 {
	color: var(--dark-text-primary) !important;
}

.desktop-vouchers-page.dark p {
	color: var(--dark-text-secondary) !important;
}

.desktop-vouchers-page.dark .noDiscounts {
	background-color: var(--dark-bg-secondary);
	color: var(--dark-text-primary);
}
</style>
